import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './Radio.module.scss';

const Radio = (props) => (
    <button
        type="button"
        className={ classnames({
            [props.styles['higgs-radio-div']]: true,
            [props.styles.checked]: props.checked
        }) }
        onClick={ () => props.onClick(!props.checked) }
    >
        { props.checked && (
            <div className={ props.styles.marker } />
        ) }
    </button>
);

Radio.propTypes = {
    checked: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    styles: PropTypes.objectOf(PropTypes.string)
};

Radio.defaultProps = {
    checked: false,
    styles
};

export default Radio;
